import { Cell, Grid, HFlow, Icon, Text, useTheme, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { ConsultasDesenvolvimentoInfantil, VisitasDomiciliaresDesenvolvimentoInfantil } from 'graphql/types.generated'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { CidadaoListagemDesenvolvimentoInfantilQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/model-acompanhamentoCondicaoSaudeListaTematica'
interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSectionProps {
  row: CidadaoListagemDesenvolvimentoInfantilQueryModel
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSectionProps>
) {
  const { row } = props
  const theme = useTheme()
  const iconColor = theme.pallete.gray.c20
  const desenvolvimentoInfantil = row.cidadao?.cidadaoConsolidado?.desenvolvimentoInfantil

  return (
    <>
      {renderConsultas(desenvolvimentoInfantil?.consultas, iconColor)}
      {renderMedicoes(desenvolvimentoInfantil?.qtdMedicoesPesoAltura, iconColor)}
      {renderVisitasDomiciliares(desenvolvimentoInfantil?.visitasDomiciliares, iconColor)}
    </>
  )
}

const renderConsultas = (consultas: ConsultasDesenvolvimentoInfantil, iconColor: string) => (
  <Grid gap={0} alignItems='baseline'>
    <Cell size={12}>
      <HFlow hSpacing={0.5} alignItems='center'>
        <Icon width='1rem' icon='teddyBear' color={iconColor} />
        <Text fontWeight='bold'>Consultas de puericultura</Text>
        <InfoIcon icon='infoCircleFilled' text='Apenas consultas médicas e de enfermagem' />
      </HFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Primeira consulta</Text>
        <Text>{formatDate(consultas?.dataPrimeiraConsulta)}</Text>
      </VFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Idade na primeira consulta</Text>
        <Text>
          {consultas?.idadeNaPrimeiraConsultaEmDias
            ? 'dia'.pluralizeAndConcatValue(consultas.idadeNaPrimeiraConsultaEmDias)
            : '-'}
        </Text>
      </VFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Consultas até 24 meses (quantidade)</Text>
        <Text>{consultas?.qtdConsultas ?? 0}</Text>
      </VFlow>
    </Cell>
  </Grid>
)

const renderMedicoes = (qtdMedicoesPesoAltura: number, iconColor: string) => (
  <Grid gap={0} alignItems='baseline'>
    <Cell size={12}>
      <HFlow hSpacing={0.5} alignItems='center'>
        <Icon width='1rem' icon='rulerFilled' color={iconColor} />
        <Text fontWeight='bold'>Medições (quantidade)</Text>
      </HFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Registros de peso e altura simultâneos até 24 meses</Text>
        <Text>{qtdMedicoesPesoAltura ?? 0}</Text>
      </VFlow>
    </Cell>
  </Grid>
)

const renderVisitasDomiciliares = (
  visitasDomiciliares: VisitasDomiciliaresDesenvolvimentoInfantil,
  iconColor: string
) => (
  <Grid gap={0} alignItems='baseline'>
    <Cell size={12}>
      <HFlow hSpacing={0.5} alignItems='center'>
        <Icon width='1rem' icon='houseFilled' color={iconColor} />
        <Text fontWeight='bold'>Visitas domiciliares</Text>
      </HFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Até 24 meses (quantidade)</Text>
        <Text>{visitasDomiciliares?.qtdVisitasDomiciliares ?? 0}</Text>
      </VFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Primeira visita</Text>
        <Text>{formatDate(visitasDomiciliares?.dataPrimeiraVisita)}</Text>
      </VFlow>
    </Cell>
    <Cell size={3}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>Segunda visita</Text>
        <Text>{formatDate(visitasDomiciliares?.dataSegundaVisita)}</Text>
      </VFlow>
    </Cell>
  </Grid>
)
